/* Тексты страницы «Способы оплаты». Разделы нумеруются автоматически при отрисовке. */

const en = {
  title: "Payment methods",
  subtitle: "Paying for Bookings on www.flyashgabat.com",
  meta: [
    { label: "Company", value: "Jahankeshde Hyzmat P.E." },
    { label: "Website", value: "https://www.flyashgabat.com" },
    { label: "Payment support", value: "payments@flyashgabat.com" },
  ],
  intro: [
    "FlyAshgabat offers several convenient payment methods for individual and corporate customers. The available methods and payment currency are displayed during the booking process.",
  ],
  sections: [
    {
      title: "Payment for Individual Customers",
      blocks: [
        { type: "text", text: "Customers may pay for a booking using:" },
        {
          type: "list",
          items: [
            "international Visa and Mastercard bank cards issued by banks in any country and enabled for foreign-currency transactions;",
            "PayPal, where this method is available for the selected country and currency;",
            "other electronic payment methods displayed on the checkout page;",
            "cash at a Company office, but only for bookings with an active payment and ticketing time limit.",
          ],
        },
        {
          type: "text",
          text: "Cash-payment availability and the payment deadline must be confirmed in advance with a FlyAshgabat representative. Payment must be completed before the booking time limit expires. Otherwise, the Supplier may cancel the fare or booking.",
        },
      ],
    },
    {
      title: "Payment for Corporate Customers",
      blocks: [
        { type: "text", text: "Corporate customers may pay using:" },
        { type: "list", items: ["a corporate bank card;", "a bank transfer against an invoice."] },
        {
          type: "text",
          text: "Tickets and other Services are issued after payment has been confirmed or the funds have reached the Company's bank account, provided that the booking time limit has not expired.",
        },
      ],
    },
    {
      title: "Payment Currency and Conversion",
      blocks: [
        {
          type: "text",
          text: "Payment is made in the currency shown on the checkout page, in the payment form or on the invoice.",
        },
        {
          type: "text",
          text: "If the card currency differs from the payment currency, the card-issuing bank may convert the transaction using its own exchange rate and may charge an additional fee. FlyAshgabat does not set that conversion rate and does not control bank or payment-system fees.",
        },
        { type: "text", text: "The final payment amount and currency are shown to the Customer before payment is confirmed." },
      ],
    },
    {
      title: "Payment Security",
      blocks: [
        {
          type: "text",
          text: "Card and electronic payments are processed through secure interfaces operated by third-party payment providers, including Stripe and PayPal where the relevant method is available.",
        },
        {
          type: "text",
          text: "When card details are entered directly into a payment provider's secure form, FlyAshgabat generally does not receive or store the complete card number or card security code (CVV/CVC).",
        },
        {
          type: "text",
          text: "For additional verification, the bank or payment system may use 3D Secure and request a one-time code, confirmation through a mobile application or another method of authentication.",
        },
        {
          type: "text",
          text: "FlyAshgabat never asks Customers to send a complete bank-card number, PIN or CVV/CVC by email, messaging service or telephone.",
        },
      ],
    },
    {
      title: "Possible Reasons for a Declined Payment",
      blocks: [
        { type: "text", text: "A bank or payment system may decline a payment for reasons including:" },
        {
          type: "list",
          items: [
            "insufficient funds on the card;",
            "the card is blocked or has expired;",
            "the card details were entered incorrectly;",
            "3D Secure authentication was not completed;",
            "the bank's transaction limit was exceeded;",
            "online payments or international transactions are disabled for the card;",
            "the transaction was declined by the bank's or payment provider's security system;",
            "the payment-confirmation time limit expired.",
          ],
        },
        { type: "text", text: "If a payment is declined, the Customer should:" },
        {
          type: "list",
          items: [
            "check the card details, available balance and applicable limits;",
            "confirm that online payments and international transactions are enabled for the card;",
            "contact the card-issuing bank;",
            "use another card or an alternative available payment method;",
            "contact FlyAshgabat customer support.",
          ],
        },
        {
          type: "text",
          text: "Customers should avoid repeatedly attempting a declined payment, as the bank's security system may temporarily block the transaction.",
        },
      ],
    },
    {
      title: "After Payment",
      blocks: [
        {
          type: "text",
          text: "A successful charge does not always mean that the ticket or other travel Service has already been issued.",
        },
        {
          type: "text",
          text: "A booking is considered confirmed after the Customer receives an electronic ticket, itinerary receipt, voucher or another document confirming the Service.",
        },
        {
          type: "text",
          text: "If funds have been charged but no booking confirmation has been received, the Customer should not make another payment and should contact FlyAshgabat customer support.",
        },
      ],
    },
    {
      title: "Refunds",
      blocks: [
        {
          type: "text",
          text: "Refunds are processed in accordance with the fare rules, the Supplier's terms and the FlyAshgabat Refund Policy.",
        },
        {
          type: "text",
          text: "As a rule, funds are returned through the same payment method used for the original transaction. The actual crediting time depends on the bank, payment system and payment method.",
        },
      ],
    },
    {
      title: "Payment Enquiries",
      blocks: [
        {
          type: "text",
          text: "For questions about payments, declined transactions, duplicate charges or refunds, please contact: payments@flyashgabat.com",
        },
        {
          type: "text",
          text: "Please include the booking number, Customer's name, and the date, amount and currency of the payment. Do not send a complete bank-card number, PIN or CVV/CVC.",
        },
      ],
    },
  ],
};

const ru = {
  title: "Способы оплаты",
  subtitle: "Оплата бронирований на www.flyashgabat.com",
  meta: [
    { label: "Компания", value: "Jahankeshde Hyzmat P.E." },
    { label: "Веб-сайт", value: "https://www.flyashgabat.com" },
    { label: "Поддержка по оплате", value: "payments@flyashgabat.com" },
  ],
  intro: [
    "FlyAshgabat предлагает физическим и юридическим лицам несколько удобных способов оплаты. Доступные способы и валюта платежа отображаются при оформлении бронирования.",
  ],
  sections: [
    {
      title: "Оплата для физических лиц",
      blocks: [
        { type: "text", text: "Клиенты могут оплатить бронирование следующими способами:" },
        {
          type: "list",
          items: [
            "международными банковскими картами Visa и Mastercard, выпущенными банками любых стран и поддерживающими оплату в иностранной валюте;",
            "через PayPal — если этот способ доступен для выбранной страны и валюты;",
            "другими электронными способами оплаты, отображаемыми на странице оформления заказа;",
            "наличными в офисе Компании — только для бронирований с действующим сроком оплаты и выписки.",
          ],
        },
        {
          type: "text",
          text: "Возможность оплаты наличными и крайний срок внесения средств необходимо предварительно подтвердить у сотрудника FlyAshgabat. Оплата должна быть произведена до окончания срока действия бронирования. В противном случае тариф или бронирование могут быть аннулированы поставщиком.",
        },
      ],
    },
    {
      title: "Оплата для юридических лиц",
      blocks: [
        { type: "text", text: "Юридическим лицам доступны:" },
        {
          type: "list",
          items: ["оплата корпоративной банковской картой;", "банковский перевод на основании выставленного счёта."],
        },
        {
          type: "text",
          text: "Оформление билетов и других услуг производится после подтверждения оплаты или поступления денежных средств на счёт Компании — при условии, что срок действия бронирования не истёк.",
        },
      ],
    },
    {
      title: "Валюта платежа и конвертация",
      blocks: [
        {
          type: "text",
          text: "Оплата производится в валюте, указанной на странице оформления заказа, в платёжной форме или в выставленном счёте.",
        },
        {
          type: "text",
          text: "Если валюта банковской карты отличается от валюты платежа, банк, выпустивший карту, может выполнить автоматическую конвертацию по собственному курсу и удержать дополнительную комиссию. FlyAshgabat не устанавливает курс такой конвертации и не контролирует комиссии банков и платёжных систем.",
        },
        { type: "text", text: "До подтверждения оплаты Клиенту показывается итоговая сумма и валюта платежа." },
      ],
    },
    {
      title: "Безопасность платежей",
      blocks: [
        {
          type: "text",
          text: "Оплата банковскими картами и через электронные платёжные системы осуществляется с использованием защищённых платёжных интерфейсов сторонних платёжных операторов, включая Stripe и PayPal, если соответствующий способ доступен.",
        },
        {
          type: "text",
          text: "При вводе данных карты непосредственно в защищённой форме платёжного оператора FlyAshgabat, как правило, не получает и не хранит полный номер карты и код безопасности CVV/CVC.",
        },
        {
          type: "text",
          text: "Для дополнительной проверки платежа банк или платёжная система могут использовать технологию 3D Secure и запросить одноразовый код, подтверждение в мобильном приложении либо другой способ идентификации.",
        },
        {
          type: "text",
          text: "FlyAshgabat никогда не просит передавать полный номер банковской карты, PIN-код или CVV/CVC по электронной почте, через мессенджеры или по телефону.",
        },
      ],
    },
    {
      title: "Возможные причины отказа в оплате",
      blocks: [
        { type: "text", text: "Банк или платёжная система могут отклонить платёж по следующим причинам:" },
        {
          type: "list",
          items: [
            "на карте недостаточно средств;",
            "карта заблокирована или срок её действия истёк;",
            "данные карты введены неверно;",
            "не пройдена проверка 3D Secure;",
            "превышен установленный банком лимит;",
            "для карты отключены интернет-платежи или международные операции;",
            "операция была отклонена системой безопасности банка или платёжного оператора;",
            "истекло время ожидания подтверждения платежа.",
          ],
        },
        { type: "text", text: "В случае отказа рекомендуется:" },
        {
          type: "list",
          items: [
            "проверить данные карты, доступный баланс и установленные лимиты;",
            "убедиться, что для карты разрешены интернет-платежи и международные операции;",
            "обратиться в банк, выпустивший карту;",
            "воспользоваться другой картой или доступным способом оплаты;",
            "обратиться в службу поддержки FlyAshgabat.",
          ],
        },
        {
          type: "text",
          text: "Не рекомендуется многократно повторять отклонённый платёж: это может привести к временной блокировке операции системой безопасности банка.",
        },
      ],
    },
    {
      title: "После оплаты",
      blocks: [
        {
          type: "text",
          text: "Успешное списание денежных средств не всегда означает, что билет или другая туристическая услуга уже оформлены.",
        },
        {
          type: "text",
          text: "Бронирование считается подтверждённым после получения Клиентом электронного билета, маршрутной квитанции, ваучера или другого документа, подтверждающего оказание услуги.",
        },
        {
          type: "text",
          text: "Если денежные средства были списаны, но подтверждение бронирования не поступило, не следует совершать повторную оплату. Необходимо обратиться в службу поддержки FlyAshgabat.",
        },
      ],
    },
    {
      title: "Возврат денежных средств",
      blocks: [
        {
          type: "text",
          text: "Возврат производится в соответствии с правилами тарифа, условиями поставщика и политикой возврата FlyAshgabat.",
        },
        {
          type: "text",
          text: "Как правило, денежные средства возвращаются тем же способом, которым была произведена оплата. Фактический срок зачисления зависит от банка, платёжной системы и способа оплаты.",
        },
      ],
    },
    {
      title: "Вопросы по оплате",
      blocks: [
        {
          type: "text",
          text: "По вопросам оплаты, отклонённых транзакций, повторных списаний и возврата денежных средств обращайтесь по адресу: payments@flyashgabat.com",
        },
        {
          type: "text",
          text: "В обращении рекомендуется указать номер бронирования, имя Клиента, дату, сумму и валюту платежа. Не отправляйте полный номер банковской карты, PIN-код или CVV/CVC.",
        },
      ],
    },
  ],
};

const tm = {
  title: "Töleg usullary",
  subtitle: "www.flyashgabat.com saýtynda bronlary tölemek",
  meta: [
    { label: "Kompaniýa", value: "Jahankeshde Hyzmat P.E." },
    { label: "Web-saýt", value: "https://www.flyashgabat.com" },
    { label: "Töleg boýunça goldaw", value: "payments@flyashgabat.com" },
  ],
  intro: [
    "FlyAshgabat şahsy we korporatiw müşderiler üçin birnäçe amatly töleg usulyny hödürleýär. Elýeterli usullar we tölegiň pul birligi bronlaşdyrmak wagtynda görkezilýär.",
  ],
  sections: [
    {
      title: "Şahsy müşderiler üçin töleg",
      blocks: [
        { type: "text", text: "Müşderiler brony şu usullar bilen töläp bilerler:" },
        {
          type: "list",
          items: [
            "islendik ýurduň banklary tarapyndan çykarylan we daşary ýurt pulunda amallara rugsat berilýän halkara Visa we Mastercard bank kartlary;",
            "saýlanan ýurt we pul birligi üçin bu usul elýeterli bolsa — PayPal;",
            "sargydy resmileşdirmek sahypasynda görkezilen beýleki elektron töleg usullary;",
            "Kompaniýanyň ofisinde nagt — diňe töleg we petek resmileşdirmek möhleti hereket edýän bronlar üçin.",
          ],
        },
        {
          type: "text",
          text: "Nagt töleg mümkinçiligini we serişdeleri geçirmegiň soňky möhletini öňünden FlyAshgabat işgäri bilen tassyklamaly. Töleg bronyň hereket ediş möhleti gutarmazdan öň amala aşyrylmalydyr. Bolmasa tarif ýa-da bron üpjün ediji tarapyndan ýatyrylyp bilner.",
        },
      ],
    },
    {
      title: "Korporatiw müşderiler üçin töleg",
      blocks: [
        { type: "text", text: "Korporatiw müşderilere şular elýeterli:" },
        { type: "list", items: ["korporatiw bank kartasy bilen töleg;", "hasap-faktura esasynda bank geçirimi."] },
        {
          type: "text",
          text: "Petekler we beýleki hyzmatlar töleg tassyklanandan ýa-da serişdeler Kompaniýanyň bank hasabyna gelip gowşandan soň, bronyň möhleti gutarmadyk ýagdaýynda resmileşdirilýär.",
        },
      ],
    },
    {
      title: "Tölegiň pul birligi we öwrülişik",
      blocks: [
        {
          type: "text",
          text: "Töleg sargydy resmileşdirmek sahypasynda, töleg formasynda ýa-da hasap-fakturada görkezilen pul birliginde amala aşyrylýar.",
        },
        {
          type: "text",
          text: "Kartanyň pul birligi tölegiň pul birliginden tapawutlanýan bolsa, kartany çykaran bank amaly öz hümmeti boýunça öwrüp we goşmaça ýygym alyp biler. FlyAshgabat şol öwrülişik hümmetini kesgitlemeýär hem-de bankyň we töleg ulgamynyň ýygymlaryna gözegçilik etmeýär.",
        },
        { type: "text", text: "Tölegiň jemi möçberi we pul birligi töleg tassyklanmazdan öň müşderä görkezilýär." },
      ],
    },
    {
      title: "Tölegiň howpsuzlygy",
      blocks: [
        {
          type: "text",
          text: "Karta we elektron tölegler üçünji tarap töleg üpjün edijileriniň, şol sanda degişli usul elýeterli bolan ýagdaýynda Stripe we PayPal-yň howpsuz interfeýsleri arkaly işlenýär.",
        },
        {
          type: "text",
          text: "Kartanyň maglumatlary göni töleg üpjün edijisiniň howpsuz formasyna girizilende FlyAshgabat, adatça, kartanyň doly belgisini ýa-da howpsuzlyk kodyny (CVV/CVC) almaýar we saklamaýar.",
        },
        {
          type: "text",
          text: "Goşmaça barlag üçin bank ýa-da töleg ulgamy 3D Secure ulanyp, bir gezeklik kody, ykjam programma arkaly tassyklamany ýa-da başga bir kesgitleme usulyny sorap biler.",
        },
        {
          type: "text",
          text: "FlyAshgabat müşderilerden bank kartasynyň doly belgisini, PIN ýa-da CVV/CVC kodyny e-poçta, habarlaşma hyzmaty ýa-da telefon arkaly ibermegi hiç haçan soramaýar.",
        },
      ],
    },
    {
      title: "Tölegiň ret edilmeginiň mümkin sebäpleri",
      blocks: [
        { type: "text", text: "Bank ýa-da töleg ulgamy tölegi şu sebäpler boýunça ret edip biler:" },
        {
          type: "list",
          items: [
            "kartada serişde ýeterlik däl;",
            "karta petiklenen ýa-da möhleti geçen;",
            "kartanyň maglumatlary nädogry girizilen;",
            "3D Secure barlagy tamamlanmadyk;",
            "bankyň amal çägi aşylan;",
            "karta üçin onlaýn tölegler ýa-da halkara amallar açylmadyk;",
            "amal bankyň ýa-da töleg üpjün edijisiniň howpsuzlyk ulgamy tarapyndan ret edilen;",
            "tölegi tassyklamagyň wagt çägi gutaran.",
          ],
        },
        { type: "text", text: "Töleg ret edilse, müşderä şulary etmek maslahat berilýär:" },
        {
          type: "list",
          items: [
            "kartanyň maglumatlaryny, elýeterli galyndyny we çäklendirmeleri barlamak;",
            "karta üçin onlaýn tölegleriň we halkara amallaryň açykdygyna göz ýetirmek;",
            "kartany çykaran banka ýüz tutmak;",
            "başga kartany ýa-da elýeterli beýleki töleg usulyny ulanmak;",
            "FlyAshgabat müşderi goldawyna ýüz tutmak.",
          ],
        },
        {
          type: "text",
          text: "Ret edilen tölegi gaýta-gaýta gaýtalamakdan saklanmaly: bankyň howpsuzlyk ulgamy amaly wagtlaýyn petikläp biler.",
        },
      ],
    },
    {
      title: "Tölegden soň",
      blocks: [
        {
          type: "text",
          text: "Serişdeleriň üstünlikli hasapdan aýrylmagy petegiň ýa-da beýleki syýahat hyzmatynyň eýýäm resmileşdirilendigini hemişe aňlatmaýar.",
        },
        {
          type: "text",
          text: "Bron müşderi elektron petegi, ýol resminamasyny, wauçeri ýa-da hyzmaty tassyklaýan başga resminamany alandan soň tassyklanan hasaplanýar.",
        },
        {
          type: "text",
          text: "Serişdeler hasapdan aýrylan, ýöne bronyň tassyklanmasy gelmedik bolsa, müşderi gaýtadan töleg etmeli däl we FlyAshgabat müşderi goldawyna ýüz tutmaly.",
        },
      ],
    },
    {
      title: "Pul serişdelerini yzyna gaýtarmak",
      blocks: [
        {
          type: "text",
          text: "Pul serişdeleri tarifiň düzgünlerine, üpjün edijiniň şertlerine we FlyAshgabat-yň yzyna gaýtarmak syýasatyna laýyklykda gaýtarylýar.",
        },
        {
          type: "text",
          text: "Adatça serişdeler ilkinji amal üçin ulanylan şol bir töleg usuly arkaly gaýtarylýar. Hakyky hasaba geçiriliş wagty banka, töleg ulgamyna we töleg usulyna baglydyr.",
        },
      ],
    },
    {
      title: "Töleg boýunça soraglar",
      blocks: [
        {
          type: "text",
          text: "Tölegler, ret edilen amallar, gaýtalanan tölegler ýa-da pul gaýtarmak boýunça soraglar üçin ýüz tutuň: payments@flyashgabat.com",
        },
        {
          type: "text",
          text: "Bronyň belgisini, müşderiniň adyny, tölegiň senesini, möçberini we pul birligini görkeziň. Bank kartasynyň doly belgisini, PIN ýa-da CVV/CVC kodyny ibermäň.",
        },
      ],
    },
  ],
};

const paymentContent = { en, ru, tm };

export default paymentContent;
